export const dashboard = {
  myItems: "Mes éléments",
  global: "Vue globale",
  favorites: "Favoris",
  recents: "Consulté récemment",
  treeNav: "Navigation en arbre",
  expand: "Aggrandir",
  powerbi: "Tableau de bord PowerBI",
};
